import styled from "styled-components";

export const PriceValue = styled.strong`
  display: block;
  color: ${p=>p.theme.colors.blue200};
  font-size: ${p=>p.theme.fonts.size600};
  line-height: 1;
  margin-top: 5px;
`;
